export * from './bs2-notificacao-webhook.dto';
